const EMAIL_ADDRESS_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmailAddress(email: string): string {
    return email.trim().toLowerCase();
}

export function isValidEmailAddress(email: string): boolean {
    return EMAIL_ADDRESS_REGEX.test(email.trim());
}
